export default [

     {
          path: '/effectiveness',
          name: 'Effectiveness',
          component: () => import("@/views/Page/Effectiveness/Effectiveness.vue"),
           meta: {
               title: 'Control Effectiveness',
          },
     }
];